<template>
  <div class="animated fadeIn">
    <p>
      <!-- Exit -->
      초기 설정 후 설정은 언제든지 변경할 수 있습니다
      <b-button class="float-right" variant="link" @click="$parent.$emit('status', false)">빠른 설정 종료</b-button>
    </p>
    <b-card-group>
      <!-- .slideInDown
      .slideInLeft
      .slideInRight
      .slideInUp
      .slideOutDown
      .slideOutLeft
      .slideOutRight
      .slideOutUp -->
      <b-card v-if="step == 1" class="slideInDown slideOutDown">
        <!-- 안내 및 설정 방법 -->
        <b-row>
          <b-col class="text-center">
            <h3>
              새 에이전트를 설치했습니다!
            </h3>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12" class="text-center">
            <b-card-group deck style="cursor:pointer">
              <b-card bg-variant="primary" @click="list">
                <b-card-text>
                  <strong>
                    다른 서버에 설정 복사
                  </strong>
                  <hr>
                  <p>다른 웹 방화벽 설정을 해당 서버에 적용합니다</p>
                  <hr>
                  <p>
                    [에이전트 선택] -> [다른 서버에 적용] -> [저장]
                  </p>
                </b-card-text>
              </b-card>
              <b-card bg-variant="success" @click="next()">
                <b-card-text>
                  <strong>
                    정책 설정
                  </strong>
                  <hr>
                  <p>빠르게 설정하고 탐지 되는 내용을 먼저 확인해 볼 수 있습니다</p>
                  <hr>
                  <p>웹 방화벽 설정 시작</p>
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 2" class="slideInLeft slideOutLeft">
        <h4>* 사용 중인 서비스를 선택하십시오</h4>
        <hr>
        <!-- 룰 설정 -->
        <RuleService ref="RuleService" :quick_setting="setting" :ico="ico" @toggle_policy="toggle_policy">  </RuleService>
        <hr>
        <b-form-group class="animated fadeIn fadeOut" style="cursor:pointer">
          <template #label>
            <p>
              <svg v-if="is_more" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-caret-down-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg>
              <svg v-else width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-caret-right-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
              </svg>
              <span @click="is_more = !is_more">더보기 : 기본 권장 사항</span>
            </p>
            <hr>
          </template>
          <ul v-if="is_more">
            <li>
              <b-form-checkbox stacked @change="toggle_all" v-model="all_selected" :indeterminate="all_indeterminate">  {{all_selected ? 'UnCheck' : 'Check'}} All
                <b-badge variant="success">{{summary_used_count || 0}}</b-badge>
              </b-form-checkbox>
            </li>
            <hr>
            <li
              v-for="(item, index) in policy_summary_list"
              v-bind:key="index"
              >
              <b-form-checkbox style="cursor:pointer;" :id="`check_${index}`" :indeterminate="item.indeterminate" v-model="item.use" stacked @change="toggle_one($event, item.value)"> {{item.text}}  </b-form-checkbox>
            </li>
          </ul>
        </b-form-group>
      </b-card>
      <b-card v-if="step == 3" class="slideInLeft slideOutLeft">
        <!-- 허용 아이피 설정 -->
        <RuleIP :origin="{ allow_ip : policy.allow_ip, block_ip : policy.block_ip }" @block_ip="($val, key) => policy.block_ip = $val" @allow_ip="($val, key) => policy.allow_ip = $val" :is_setup="true"></RuleIP>
      </b-card>
      <b-card v-if="step == 4" class="slideInLeft slideOutLeft">
        <!-- 경로 설정 -->
        <RuleCustom
          :origin="policy.path"
          name="path"
          :is_setup="true"
          example="/admin,/manager,/images"
          @update="($val, key) => policy.path = $val"
        ></RuleCustom>
      </b-card>
      <b-card v-if="step == 5" class="slideInLeft slideOutLeft">
        <!-- 운영 모드 및 레벨 확인 -->
        <RuleMode
          :setting="policy"
          :is_first="is_first"
          @update="($val, key) => policy[key] = $val"
        >
        </RuleMode>
      </b-card>
    </b-card-group>
    <!-- 스탭 공통 처리 부분 -->
    <hr v-if="step < all">
    <b-button v-if="step > 1" block size="sm" variant="info" @click="prev()"> 이전 </b-button>
    <b-button v-if="step < all"  block size="sm" variant="primary" @click="next()">다음 </b-button>
    <b-button class="btn-add" v-else  block size="sm" variant="success" @click="modal_save = true">저장 </b-button>
    <hr>
    <b-row>
      <b-col>
        <center>{{step}} / {{all}}</center>
      </b-col>
    </b-row>
    <b-modal title="Policy Apply to agent(WAF)"  class="modal-success" v-model="modal_save" @ok="apply" ok-variant="success" header-bg-variant="warning">
      설정을 적용할까요 ?
      <hr>
      탐지 모드를 사용하면 탐지된 로그를 차단하지 않고 확인할 수 있습니다
      <br>
      설정은 언제든지 변경할 수 있습니다
    </b-modal>
    <!-- 디버그 영역 -->
    <!-- {{policy}} -->
    <!-- {{policy_summary_list}} -->
    <!-- {{policy.rule}} -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
